(function () {
var $ = function (id) { return document.getElementById(id); };
var wrap = $('csf-wrap');
if (!wrap || !$('csf_go')) return;

var mount = $('sharpening-form-mount');
if (mount && mount.parentNode) { mount.parentNode.replaceChild(wrap, mount); }

var ROWS = 4;
var tb = $('csf_order').getElementsByTagName('tbody')[0];
for (var r = 0; r < ROWS; r++) {
  var tr = document.createElement('tr');
  for (var c = 0; c < 6; c++) {
    var td = document.createElement('td');
    var inp = document.createElement('input');
    inp.type = 'text';
    inp.className = 'csf_cell';
    inp.setAttribute('data-r', r);
    inp.setAttribute('data-c', c);
    td.appendChild(inp);
    tr.appendChild(td);
  }
  tb.appendChild(tr);
}

var d = new Date();
$('csf_date').value = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);

function esc(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function val(id) { var e = $(id); return e ? e.value.trim() : ''; }
function payMode() {
  var r = document.getElementsByName('csf_pay');
  for (var i = 0; i < r.length; i++) { if (r[i].checked) return r[i].value; }
  return 'call';
}
function prettyDate(iso) {
  if (!iso) return '';
  var p = iso.split('-');
  if (p.length !== 3) return iso;
  return p[1].replace(/^0/, '') + '/' + p[2].replace(/^0/, '') + '/' + p[0];
}
function orderRows() {
  var cells = document.getElementsByClassName('csf_cell');
  var grid = [], i, r, c;
  for (r = 0; r < ROWS; r++) { grid.push(['', '', '', '', '', '']); }
  for (i = 0; i < cells.length; i++) {
    r = parseInt(cells[i].getAttribute('data-r'), 10);
    c = parseInt(cells[i].getAttribute('data-c'), 10);
    grid[r][c] = cells[i].value.trim();
  }
  return grid;
}
function fieldRow(label, value) {
  return '<div class="fr"><span class="fl">' + label + '</span><span class="fv">' + esc(value) + '</span></div>';
}

function buildDoc(blank) {
  var pay = blank ? '' : payMode();
  var callBox = (pay === 'call') ? '&#10005;' : '';
  var rows = blank ? [['','','','','',''],['','','','','',''],['','','','','',''],['','','','','','']] : orderRows();
  var rowHtml = '', i, c;
  for (i = 0; i < rows.length; i++) {
    rowHtml += '<tr>';
    for (c = 0; c < 6; c++) { rowHtml += '<td>' + esc(rows[i][c]) + '</td>'; }
    rowHtml += '</tr>';
  }

  var payNote = '';
  if (pay === 'call') { payNote = 'Customer asked us to call for card details.'; }
  else if (pay === 'write') { payNote = 'Customer is writing card details on this form by hand.'; }
  else if (pay === 'net30') { payNote = 'Bill to Net 30 account.'; }

  var css = '@page{size:letter;margin:.4in}' +
    '*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}' +
    'body{margin:0;font-family:Helvetica,Arial,sans-serif;color:#1C2430;font-size:10.5px;line-height:1.35}' +
    'html,body{overflow:hidden}' +
    '#page{height:8.8in;overflow:hidden;break-inside:avoid;page-break-inside:avoid}' +
    '#pg{width:112.5%;height:9.9in;overflow:hidden;transform:scale(.8889);transform-origin:top left}' +
    '.bx,.sh,.ban,.cols,.col,table,tr,.intro,.hd{break-inside:avoid;page-break-inside:avoid}' +
    '.hd{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:3px solid #BF0A30;padding-bottom:8px;margin-bottom:10px}' +
    '.ttl{font-size:21px;font-weight:bold;color:#002768;letter-spacing:-.3px;line-height:1.05}' +
    '.ttl span{display:block;font-size:15px;color:#BF0A30;letter-spacing:.5px}' +
    '.sub{font-size:9px;color:#444;margin-top:3px}' +
    '.badges{text-align:right}' +
    '.bdg{display:inline-block;background:#BF0A30;color:#fff;font-size:9px;font-weight:bold;padding:4px 8px;letter-spacing:.4px}' +
    '.bdg2{display:inline-block;border:1.5px solid #002768;color:#002768;font-size:9px;font-weight:bold;padding:3px 8px;letter-spacing:.4px;margin-left:4px}' +
    '.cont{font-size:9px;color:#002768;font-weight:bold;margin-top:5px;letter-spacing:.3px}' +
    '.intro{background:#EEF2F9;border:1px solid #D4DEEE;padding:6px 9px;font-size:9.5px;margin-bottom:7px}' +
    '.intro b{color:#002768}' +
    '.sh{background:#DCE4F2;color:#002768;font-size:10px;font-weight:bold;letter-spacing:.7px;padding:5px 9px;display:flex;justify-content:space-between;align-items:center}' +
    '.sh em{font-style:normal;font-weight:normal;font-size:8.5px;color:#4A5A75}' +
    '.bx{border:1px solid #C8D3E6;border-top:0;padding:8px 9px;margin-bottom:7px}' +
    '.grid{display:flex;flex-wrap:wrap}' +
    '.fr{width:50%;display:flex;align-items:flex-end;padding:0 10px 7px 0}' +
    '.fl{font-weight:bold;font-size:10px;white-space:nowrap;margin-right:7px}' +
    '.fv{flex:1;border-bottom:1px solid #8795AC;min-height:15px;padding:0 3px 1px;font-size:11px}' +
    '.sub2{color:#BF0A30;font-weight:bold;font-size:9.5px;letter-spacing:.5px;margin:2px 0 8px}' +
    '.chk{display:inline-block;width:11px;height:11px;border:1.5px solid #1C2430;text-align:center;line-height:10px;font-size:10px;vertical-align:-2px;margin:0 4px}' +
    '.qty{display:flex;align-items:center;gap:10px;margin-bottom:8px}' +
    '.qtyb{border:1.5px solid #1C2430;min-width:46px;height:24px;text-align:center;font-size:14px;font-weight:bold;line-height:22px}' +
    '.ban{background:#BF0A30;color:#fff;text-align:center;padding:7px}' +
    '.ban b{font-size:13px;letter-spacing:.3px}' +
    '.ban div{font-size:9px;margin-top:2px}' +
    'table{width:100%;border-collapse:collapse;font-size:10px}' +
    'th{background:#8C0A26;color:#fff;font-size:8.5px;letter-spacing:.4px;padding:4px;border:1px solid #8C0A26}' +
    'td{border:1px solid #C8A0AC;height:17px;padding:1px 5px}' +
    '.cols{display:flex;gap:8px;margin-top:7px}' +
    '.col{flex:1;border:1px solid #C8D3E6}' +
    '.colh{background:#DCE4F2;color:#002768;font-size:9.5px;font-weight:bold;letter-spacing:.5px;padding:4px 8px}' +
    '.colb{padding:7px;font-size:9px}' +
    '.colb li{margin-bottom:4px}' +
    '.colb ul{margin:0;padding-left:13px}' +
    '.ship{border:2px solid #BF0A30;text-align:center;padding:9px 6px}' +
    '.ship .n{font-size:15px;font-weight:bold;color:#002768;line-height:1.25}' +
    '.ship .a{font-size:13px;font-weight:bold;color:#002768;line-height:1.3}' +
    '.ship .c{font-size:10px;margin-top:5px}' +
    '.ft{text-align:center;font-size:8px;color:#7A8699;margin-top:6px;letter-spacing:.3px}' +
    '.note{font-size:9px;color:#8C0A26;font-weight:bold;margin-top:6px}';

  var body = '<div id="page"><div id="pg">' +
    '<div class="hd"><div><div class="ttl">COLD SAW SHOP<span>SHARPENING FORM</span></div>' +
    '<div class="sub">High speed steel cold saw blades &middot; all brands, OEM and competitor</div></div>' +
    '<div class="badges"><span class="bdg">24 HOUR TURNAROUND</span><span class="bdg2">SHARPENED IN ANNA, TEXAS</span>' +
    '<div class="cont">COLDSAWSHOP.COM &middot; (855) 729-7732</div></div></div>' +

    '<div class="intro"><b>THIS IS ALL WE DO.</b> Your blades are sharpened on the most technologically advanced CNC equipment built, machines made specifically for sharpening and manufacturing high speed steel saw blades. Every blade goes back ground to original factory geometry. Every brand, OEM and competitor alike.</div>' +

    '<div class="sh"><span>SHIPPING INFORMATION</span><em>where your blades go back</em></div>' +
    '<div class="bx"><div class="grid">' +
    fieldRow('Company name', blank ? '' : val('csf_company')) +
    fieldRow('Contact name', blank ? '' : val('csf_contact')) +
    fieldRow('Street address', blank ? '' : val('csf_street')) +
    fieldRow('City, State, ZIP', blank ? '' : val('csf_city')) +
    fieldRow('Email', blank ? '' : val('csf_email')) +
    fieldRow('Phone', blank ? '' : val('csf_phone')) +
    '</div></div>' +

    '<div class="sh"><span>PAYMENT</span><em>all major credit cards &middot; Net 30 available on credit approval</em></div>' +
    '<div class="bx"><div class="sub2">CREDIT CARD</div><div class="grid">' +
    fieldRow('Card number', '') + fieldRow('Card holder', '') +
    fieldRow('Expiration date', '') + fieldRow('3 / 4 digit CVC', '') +
    '</div><div style="font-size:10px;font-weight:bold;margin:2px 0 9px">Prefer not to write your card down? Check here <span class="chk">' + callBox + '</span> and we will call for it.</div>' +
    '<div class="sub2">WHO DO WE CONTACT FOR PAYMENT?</div><div class="grid">' +
    fieldRow('Contact name', blank ? '' : val('csf_contact')) +
    fieldRow('Phone', blank ? '' : val('csf_phone')) +
    fieldRow('Email', blank ? '' : val('csf_email')) +
    fieldRow('PO number', blank ? '' : val('csf_po')) +
    '</div>' + (payNote ? '<div class="note">' + payNote + '</div>' : '') + '</div>' +

    '<div class="sh"><span>HOW MANY BLADES ARE YOU SENDING?</span></div>' +
    '<div class="bx"><div class="qty"><span style="font-size:12px;font-weight:bold">TOTAL BLADES ENCLOSED</span>' +
    '<span class="qtyb">' + (blank ? '' : esc(val('csf_qty'))) + '</span>' +
    '<span style="font-size:10px">Date sent</span><span style="border-bottom:1px solid #8795AC;min-width:95px;padding:0 4px;font-size:11px">' + (blank ? '' : esc(prettyDate(val('csf_date')))) + '</span></div>' +
    '<div style="font-size:10px;font-weight:bold;margin-bottom:4px">Comments or special instructions:</div>' +
    '<div style="border:1px solid #8795AC;height:44px;overflow:hidden;padding:4px 7px;font-size:10px;white-space:pre-wrap">' + (blank ? '' : esc(val('csf_notes'))) + '</div></div>' +

    '<div class="ban"><b>FREE RETURN SHIPPING ON YOUR SHARPENING</b><div>Buy any new blade on this form and we ship your sharpened blades back in the same box, at no charge to you.</div></div>' +
    '<div style="border:1px solid #C8A0AC;border-top:0;padding:9px">' +
    '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px"><span style="color:#8C0A26;font-weight:bold;font-size:10.5px;letter-spacing:.5px">ORDER NEW BLADES</span><span style="font-size:8.5px;color:#4A5A75">fill in anything you need and we quote it with your sharpening</span></div>' +
    '<table><thead><tr><th>QTY</th><th>DIAMETER</th><th>THICKNESS</th><th>BORE</th><th># TEETH</th><th>APPLICATION / MATERIAL BEING CUT</th></tr></thead><tbody>' + rowHtml + '</tbody></table></div>' +

    '<div class="cols"><div class="col"><div class="colh">PACKING &amp; SHIPPING</div><div class="colb"><ul>' +
    '<li>Wrap all blades together in a box that fits, then secure them with packing material. Loose blades arrive damaged.</li>' +
    '<li>Put this form in the box. Blades without a form wait until we can reach you.</li>' +
    '<li><b style="color:#8C0A26">Notch grind is extra.</b> Tell us above if your blades are notched.</li>' +
    '<li><b style="color:#8C0A26">Broken teeth cost extra.</b> Gumming out a broken tooth, or re-toothing, is additional.</li>' +
    '</ul></div></div>' +
    '<div class="col"><div class="colh" style="background:#FBE4EA;color:#8C0A26">SHIP YOUR BLADES TO</div><div class="colb"><div class="ship">' +
    '<div class="n">COLD SAW SHOP</div><div class="a">5005 PRIVATE RD 5934<br>ANNA, TX 75409</div>' +
    '<div class="c">(855) 729-7732<br>info@coldsawshop.com</div></div></div></div>' +
    '<div class="col"><div class="colh">BEFORE YOU SHIP</div><div class="colb">' +
    '<div style="font-size:9.5px;line-height:1.5">Call <b>(855) 729-7732</b> and let us know the box is coming. Blades we are expecting get scheduled in before they arrive, which is the single biggest thing that moves your turn time.</div>' +
    '<div style="margin-top:7px;font-size:9.5px">Full price list, every size in HSS and carbide:<br><b>coldsawshop.com/pages/blade-sharpening</b></div>' +
    '</div></div></div>' +

    '<div class="ft">PRECISION. PERFORMANCE. DELIVERED. &middot; Pricing effective September 2026 and subject to change.</div>' +
    '</div></div>';

  return '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Cold Saw Shop Sharpening Form</title><style>' + css + '</style></head><body>' + body + '</body></html>';
}

function orderSummary() {
  var g = orderRows(), out = [], i;
  for (i = 0; i < g.length; i++) {
    if (g[i].join('').trim() === '') continue;
    out.push('qty ' + (g[i][0] || '?') + ' / dia ' + (g[i][1] || '?') + ' / thk ' + (g[i][2] || '?') +
             ' / bore ' + (g[i][3] || '?') + ' / teeth ' + (g[i][4] || '?') + ' / ' + (g[i][5] || ''));
  }
  return out.length ? out.join('\n') : 'none';
}

function payLabel() {
  var p = payMode();
  if (p === 'call') return 'Call customer for card details';
  if (p === 'write') return 'Card written on the printed form';
  return 'Net 30 account';
}

var CSF_LOG_URL = 'https://script.google.com/macros/s/AKfycbw0Dlu5Hkg3LWJqQxD4-npTQqRUGO9AhW-bjrsYiw5K2G0hg5egCIAIpzkGvEZm-jWM/exec';

function logToSheet() {
  try {
    var payload = {
      company: val('csf_company'),
      contact: val('csf_contact'),
      phone: val('csf_phone'),
      email: val('csf_email'),
      address: val('csf_street') + ', ' + val('csf_city'),
      qty: val('csf_qty'),
      shipDate: prettyDate(val('csf_date')),
      po: val('csf_po'),
      payment: payLabel(),
      notes: val('csf_notes'),
      newBlades: orderSummary()
    };
    fetch(CSF_LOG_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  } catch (e) {}
}

function openPrint(html) {
  var w = window.open('', '_blank');
  if (!w) {
    var e = $('csf_error');
    e.style.display = 'block';
    e.innerHTML = 'Your browser blocked the print window. Allow pop-ups for this site and try again, or call us at (855) 729-7732 and we will email you a form.';
    return;
  }
  w.document.open();
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(function () { w.print(); }, 450);
}

$('csf_go').addEventListener('click', function () {
  var missing = [];
  if (!val('csf_company')) missing.push('company name');
  if (!val('csf_contact')) missing.push('contact name');
  if (!val('csf_street')) missing.push('street address');
  if (!val('csf_city')) missing.push('city, state, ZIP');
  if (!val('csf_email')) missing.push('email');
  if (!val('csf_phone')) missing.push('phone');
  if (!val('csf_qty')) missing.push('how many blades');
  var e = $('csf_error');
  if (missing.length) {
    e.style.display = 'block';
    e.innerHTML = 'We still need your ' + missing.join(', ') + '.';
    e.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  e.style.display = 'none';
  logToSheet();
  openPrint(buildDoc(false));
});

$('csf_blank').addEventListener('click', function () { openPrint(buildDoc(true)); });
})();